export const INDIAN_LOCATIONS: string[] = [
    'Dausa - Rajasthan',
    'Mahwa - Rajasthan',
    'Dholpur - Rajasthan',
    'Hindaun - Rajasthan',
    'Bandikui - Rajasthan',
    'Sawai Madhopur - Rajasthan',
    'Gangapur City - Rajasthan',
    'Lucknow - GN',
    'Lucknow - HG',
    'Prayagraj',
    'Lucknow - AG',
    'Meerut',
    'Gwalior',
    'Jodhpur',
    'Jaipur - GC',
    'Bhopal',
    'Chennai',
    'Patna - BR',
    'Kota - IP',
    'Delhi - LN',
    'Hubballi',
    'Kolkata',
    'Indore - VN',
    'Kolhapur',
    'Pune - SG',
    'Patna - KB',
    'Mumbai',
    'Aligarh',
    'Coimbatore',
    'Indore - BK',
    'Haldwani',
    'Gorakhpur',
    'Indore - MM + RC',
    'Noida',
    'Bangalore - Rajaji Nagar',
    'Guwahati',
    'Pune - PC',
    'Nashik - CR',
    'Ahmedabad',
    'Hyderabad - TR',
    'Vizag - RG',
    'Puducherry',
    'Agra',
    'Hyderabad - KC',
    'Raipur',
    'Pune - VN',
    'Bangalore - Jayanagar',
    'Mysore',
    'Vijayawada - CM',
    'Chandigarh',
    'Nashik - NR',
    'Muzaffarpur',
    'Vijayawada - EP',
    'Solapur',
    'Varanasi',
    'Bhilai',
    'Agartala',
    'Bilaspur',
    'Kakinada',
    'Hyderabad - BHEL',
    'Chattrapati Sambhaji Nagar',
    'Samastipur',
    'Bangalore - RR Nagar',
    'Pune - HP',
    'Guntur',
    'Narayangaon',
    'Jammu - NR',
    'Ernakulam',
    'Srinagar',
    'Amravati',
    'Baramati',
    'Bhimavaram',
    'Bikaner',
    'Burhanpur',
    'Ghaziabad',
    'Hyderabad - MP',
    'Kozhikode - Calicut',
    'Moradabad',
    'Rajahmundry',
    'Tirupati',
    'Ujjain',
    'Yavatmal',
    'Visakhapatnam - Andhra Pradesh',
    'Vijayawada - Andhra Pradesh',
    'Guntur - Andhra Pradesh',
    'Tirupati - Andhra Pradesh',
    'Rajahmundry - Andhra Pradesh',
    'Kurnool - Andhra Pradesh',
    'Nellore - Andhra Pradesh',
    'Ananthapur - Andhra Pradesh',
    'Itanagar - Arunachal Pradesh',
    'Tawang - Arunachal Pradesh',
    'Pasighat - Arunachal Pradesh',
    'Ziro - Arunachal Pradesh',
    'Bomdila - Arunachal Pradesh',
    'Guwahati - Assam',
    'Dibrugarh - Assam',
    'Silchar - Assam',
    'Jorhat - Assam',
    'Nagaon - Assam',
    'Patna - Bihar',
    'Gaya - Bihar',
    'Muzaffarpur - Bihar',
    'Bhagalpur - Bihar',
    'Darbhanga - Bihar',
    'Purnia - Bihar',
    'Raipur - Chhattisgarh',
    'Bilaspur - Chhattisgarh',
    'Durg - Chhattisgarh',
    'Bhilai - Chhattisgarh',
    'Korba - Chhattisgarh',
    'Jagdalpur - Chhattisgarh',
    'Panaji - Goa',
    'Margao - Goa',
    'Vasco da Gama - Goa',
    'Mapusa - Goa',
    'Ponda - Goa',
    'Ahmedabad - Gujarat',
    'Surat - Gujarat',
    'Vadodara - Gujarat',
    'Rajkot - Gujarat',
    'Bhavnagar - Gujarat',
    'Jamnagar - Gujarat',
    'Junagadh - Gujarat',
    'Gandhinagar - Gujarat',
    'Gurugram - Haryana',
    'Faridabad - Haryana',
    'Panipat - Haryana',
    'Karnal - Haryana',
    'Ambala - Haryana',
    'Hisar - Haryana',
    'Rohtak - Haryana',
    'Sonipat - Haryana',
    'Shimla - Himachal Pradesh',
    'Dharamshala - Himachal Pradesh',
    'Solan - Himachal Pradesh',
    'Mandi - Himachal Pradesh',
    'Kullu - Himachal Pradesh',
    'Hamirpur - Himachal Pradesh',
    'Ranchi - Jharkhand',
    'Jamshedpur - Jharkhand',
    'Dhanbad - Jharkhand',
    'Bokaro - Jharkhand',
    'Hazaribagh - Jharkhand',
    'Deoghar - Jharkhand',
    'Bengaluru - Karnataka',
    'Mysuru - Karnataka',
    'Mangaluru - Karnataka',
    'Hubballi - Karnataka',
    'Belagavi - Karnataka',
    'Shivamogga - Karnataka',
    'Tumakuru - Karnataka',
    'Thiruvananthapuram - Kerala',
    'Kochi - Kerala',
    'Kozhikode - Kerala',
    'Thrissur - Kerala',
    'Kollam - Kerala',
    'Kannur - Kerala',
    'Bhopal - Madhya Pradesh',
    'Indore - Madhya Pradesh',
    'Gwalior - Madhya Pradesh',
    'Jabalpur - Madhya Pradesh',
    'Ujjain - Madhya Pradesh',
    'Sagar - Madhya Pradesh',
    'Mumbai - Maharashtra',
    'Pune - Maharashtra',
    'Nagpur - Maharashtra',
    'Nashik - Maharashtra',
    'Thane - Maharashtra',
    'Aurangabad - Maharashtra',
    'Kolhapur - Maharashtra',
    'Solapur - Maharashtra',
    'Imphal - Manipur',
    'Thoubal - Manipur',
    'Bishnupur - Manipur',
    'Churachandpur - Manipur',
    'Shillong - Meghalaya',
    'Tura - Meghalaya',
    'Jowai - Meghalaya',
    'Nongpoh - Meghalaya',
    'Aizawl - Mizoram',
    'Lunglei - Mizoram',
    'Champhai - Mizoram',
    'Kolasib - Mizoram',
    'Kohima - Nagaland',
    'Dimapur - Nagaland',
    'Mokokchung - Nagaland',
    'Wokha - Nagaland',
    'Bhubaneswar - Odisha',
    'Cuttack - Odisha',
    'Rourkela - Odisha',
    'Sambalpur - Odisha',
    'Berhampur - Odisha',
    'Ludhiana - Punjab',
    'Amritsar - Punjab',
    'Jalandhar - Punjab',
    'Patiala - Punjab',
    'Bathinda - Punjab',
    'Mohali - Punjab',
    'Jaipur - Rajasthan',
    'Jodhpur - Rajasthan',
    'Udaipur - Rajasthan',
    'Kota - Rajasthan',
    'Ajmer - Rajasthan',
    'Bikaner - Rajasthan',
    'Alwar - Rajasthan',
    'Gangtok - Sikkim',
    'Namchi - Sikkim',
    'Geyzing - Sikkim',
    'Mangan - Sikkim',
    'Chennai - Tamil Nadu',
    'Coimbatore - Tamil Nadu',
    'Madurai - Tamil Nadu',
    'Tiruchirappalli - Tamil Nadu',
    'Salem - Tamil Nadu',
    'Tirunelveli - Tamil Nadu',
    'Erode - Tamil Nadu',
    'Hyderabad - Telangana',
    'Warangal - Telangana',
    'Nizamabad - Telangana',
    'Karimnagar - Telangana',
    'Khammam - Telangana',
    'Agartala - Tripura',
    'Udaipur - Tripura',
    'Dharmanagar - Tripura',
    'Kailasahar - Tripura',
    'Lucknow - Uttar Pradesh',
    'Kanpur - Uttar Pradesh',
    'Agra - Uttar Pradesh',
    'Varanasi - Uttar Pradesh',
    'Prayagraj - Uttar Pradesh',
    'Meerut - Uttar Pradesh',
    'Noida - Uttar Pradesh',
    'Ghaziabad - Uttar Pradesh',
    'Dehradun - Uttarakhand',
    'Haridwar - Uttarakhand',
    'Haldwani - Uttarakhand',
    'Rishikesh - Uttarakhand',
    'Roorkee - Uttarakhand',
    'Kolkata - West Bengal',
    'Howrah - West Bengal',
    'Durgapur - West Bengal',
    'Siliguri - West Bengal',
    'Asansol - West Bengal',
    'Kharagpur - West Bengal',
    'Srinagar - Jammu & Kashmir',
    'Chandigarh - Chandigarh',
    'Adugodi - Bengaluru',
    'Agara - Bengaluru',
    'Akshayanagar - Bengaluru',
    'Amruthahalli - Bengaluru',
    'Anjanapura - Bengaluru',
    'Arekere - Bengaluru',
    'Ashok Nagar - Bengaluru',
    'Attibele - Bengaluru',
    'Austin Town - Bengaluru',
    'Avalahalli - Bengaluru',
    'Bagalur - Bengaluru',
    'Banashankari - Bengaluru',
    'Banaswadi - Bengaluru',
    'Bannerghatta Road - Bengaluru',
    'Basavanagudi - Bengaluru',
    'Basaveshwaranagar - Bengaluru',
    'Battarahalli - Bengaluru',
    'Begur - Bengaluru',
    'Bellandur - Bengaluru',
    'Benson Town - Bengaluru',
    'Bharath Nagar - Bengaluru',
    'Bilekahalli - Bengaluru',
    'Bommanahalli - Bengaluru',
    'Bommasandra - Bengaluru',
    'Brookefield - Bengaluru',
    'BTM Layout - Bengaluru',
    'Byatarayanapura - Bengaluru',
    'Byrasandra - Bengaluru',
    'CV Raman Nagar - Bengaluru',
    'Challaghatta - Bengaluru',
    'Chamarajpet - Bengaluru',
    'Chandapura - Bengaluru',
    'Chandra Layout - Bengaluru',
    'Cox Town - Bengaluru',
    'Cooke Town - Bengaluru',
    'Cunningham Road - Bengaluru',
    'Dasarahalli - Bengaluru',
    'Devanahalli - Bengaluru',
    'Devarachikkanahalli - Bengaluru',
    'Devasandra - Bengaluru',
    'Doddaballapur Road - Bengaluru',
    'Doddakallasandra - Bengaluru',
    'Doddakannelli - Bengaluru',
    'Dollars Colony - Bengaluru',
    'Domlur - Bengaluru',
    'Dooravani Nagar - Bengaluru',
    'Electronic City - Bengaluru',
    'Frazer Town - Bengaluru',
    'Ganganagar - Bengaluru',
    'Girinagar - Bengaluru',
    'Gottigere - Bengaluru',
    'HBR Layout - Bengaluru',
    'HSR Layout - Bengaluru',
    'HAL Layout - Bengaluru',
    'Haralur - Bengaluru',
    'Hebbal - Bengaluru',
    'Hegde Nagar - Bengaluru',
    'Hennur - Bengaluru',
    'Hoodi - Bengaluru',
    'Horamavu - Bengaluru',
    'Hosur Road - Bengaluru',
    'Hulimavu - Bengaluru',
    'Indiranagar - Bengaluru',
    'ISRO Layout - Bengaluru',
    'Jakkur - Bengaluru',
    'Jalahalli - Bengaluru',
    'Jayanagar - Bengaluru',
    'Jeevan Bima Nagar - Bengaluru',
    'JP Nagar - Bengaluru',
    'Judicial Layout - Bengaluru',
    'Kadubeesanahalli - Bengaluru',
    'Kadugodi - Bengaluru',
    'Kaggadasapura - Bengaluru',
    'Kalyan Nagar - Bengaluru',
    'Kamakshipalya - Bengaluru',
    'Kanakapura Road - Bengaluru',
    'Kasavanahalli - Bengaluru',
    'Kasturi Nagar - Bengaluru',
    'Kathriguppe - Bengaluru',
    'Kengeri - Bengaluru',
    'Kodigehalli - Bengaluru',
    'Kodihalli - Bengaluru',
    'Kogilu - Bengaluru',
    'Konanakunte - Bengaluru',
    'Koramangala - Bengaluru',
    'KR Puram - Bengaluru',
    'Kumaraswamy Layout - Bengaluru',
    'Kundalahalli - Bengaluru',
    'Laggere - Bengaluru',
    'Lavelle Road - Bengaluru',
    'Magadi Road - Bengaluru',
    'Mahadevapura - Bengaluru',
    'Mahalakshmi Layout - Bengaluru',
    'Malleshwaram - Bengaluru',
    'Marathahalli - Bengaluru',
    'Mathikere - Bengaluru',
    'MG Road - Bengaluru',
    'Munnekollal - Bengaluru',
    'Murugeshpalya - Bengaluru',
    'Nagadevanahalli - Bengaluru',
    'Nagarbhavi - Bengaluru',
    'Nagasandra - Bengaluru',
    'Nagavara - Bengaluru',
    'Nandini Layout - Bengaluru',
    'Nayandahalli - Bengaluru',
    'Neeladri Nagar - Bengaluru',
    'Old Airport Road - Bengaluru',
    'Old Madras Road - Bengaluru',
    'Padmanabhanagar - Bengaluru',
    'Palace Guttahalli - Bengaluru',
    'Peenya - Bengaluru',
    'Pulikeshi Nagar - Bengaluru',
    'Puttenahalli - Bengaluru',
    'Race Course Road - Bengaluru',
    'Rajajinagar - Bengaluru',
    'Rajarajeshwari Nagar - Bengaluru',
    'Ramamurthy Nagar - Bengaluru',
    'Richmond Town - Bengaluru',
    'Richards Town - Bengaluru',
    'RMV Extension - Bengaluru',
    'RT Nagar - Bengaluru',
    'Sadashivanagar - Bengaluru',
    'Sahakar Nagar - Bengaluru',
    'Sanjay Nagar - Bengaluru',
    'Sarjapur - Bengaluru',
    'Sarjapur Road - Bengaluru',
    'Shanti Nagar - Bengaluru',
    'Sheshadripuram - Bengaluru',
    'Shivajinagar - Bengaluru',
    'Singasandra - Bengaluru',
    'Subramanyapura - Bengaluru',
    'Sudhama Nagar - Bengaluru',
    'Thanisandra - Bengaluru',
    'Ulsoor - Bengaluru',
    'Uttarahalli - Bengaluru',
    'Varthur - Bengaluru',
    'Vasanth Nagar - Bengaluru',
    'Vidyaranyapura - Bengaluru',
    'Vignan Nagar - Bengaluru',
    'Vijayanagar - Bengaluru',
    'Vimanapura - Bengaluru',
    'Virgonagar - Bengaluru',
    'Visvesvaraya Layout - Bengaluru',
    'Whitefield - Bengaluru',
    'Wilson Garden - Bengaluru',
    'Yelahanka - Bengaluru',
    'Yelachenahalli - Bengaluru',
    'Yeshwanthpur - Bengaluru'
];
